import React, { useState } from 'react'
import { TextField, Button, Dialog } from '@material-ui/core'
import useSubmitRunMutation from './graphql/useSubmitRunMutation'

export default ({ onClose, open }) => {
  const submitRun = useSubmitRunMutation()
  const [name, setName] = useState('')
  const [nameError, setNameError] = useState(false)
  const [miles, setMiles] = useState('')
  const [milesError, setMilesError] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)

  const onSubmit = async () => {
    const mileage = parseFloat(miles)

    setNameError(
      !name || name.trim().length <= 0 ? 'Name must be filled out.' : false
    )
    if (isNaN(mileage)) {
      setMilesError('Miles must be a valid number (e.g. 13.1).')
    } else if (mileage <= 0) {
      setMilesError('Miles must be greater than 0.')
    }

    if (
      name &&
      name.trim().length >= 0 &&
      miles &&
      !isNaN(mileage) &&
      mileage > 0
    ) {
      try {
        setSubmitLoading(true)
        const result = await submitRun({ name: name.trim(), mileage })
        console.log('Result!', result)
        setName('')
        setMiles('')
        onClose()
      } catch (e) {
        console.log('Error submitting!', e)
      } finally {
        setSubmitLoading(false)
      }
    }
  }

  return (
    <Dialog onClose={onClose} open={open}>
      <div style={{ padding: 20 }}>
        <div
          style={{
            display: 'flex',
            flexFlow: 'column nowrap',
          }}
        >
          <TextField
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '20px',
            }}
            required={true}
            error={!!nameError}
            helperText={nameError}
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={submitLoading}
          />
          <TextField
            style={{ display: 'flex', justifyContent: 'space-between' }}
            required={true}
            error={!!milesError}
            helperText={milesError}
            label="Miles"
            value={miles}
            onChange={(e) => {
              setMiles(e.target.value)
            }}
            disabled={submitLoading}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ marginTop: '20px' }}
            onClick={() => onSubmit()}
            disabled={submitLoading}
            loading={submitLoading}
          >
            Submit My Run!
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
